import { inviteApi as api } from './inviteApi';
export const addTagTypes = ['Invite'] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes
  })
  .injectEndpoints({
    endpoints: build => ({
      getUninvitedPeople: build.query<
        GetUninvitedPeopleApiResponse,
        GetUninvitedPeopleApiArg
      >({
        query: ({ name }) => ({
          url: `/uninvitedPeople`,
          params: { name }
        }),
        providesTags: ['Invite']
      }),
      invitePeople: build.mutation<InvitePeopleApiResponse, InvitePeopleApiArg>(
        {
          query: queryArg => ({
            url: `/invitePeople`,
            method: 'POST',
            body: queryArg.sharedAssetBody
          }),
          invalidatesTags: ['Invite']
        }
      ),
      getInvitedPeople: build.query<
        GetInvitedPeopleApiResponse,
        GetInvitedPeopleApiArg
      >({
        query: () => ({ url: `/invitePeople` }),
        providesTags: ['Invite']
      }),
      getContributors: build.query<
        GetContributorsApiResponse,
        GetContributorsApiArg
      >({
        query: queryArg => ({
          url: `/contributors`,
          params: { type: queryArg['type'] }
        }),
        providesTags: ['Invite']
      }),
      getMySpace: build.query<GetMySpaceApiResponse, GetMySpaceApiArg>({
        query: () => ({ url: `/getMySpace` }),
        providesTags: ['Invite']
      })
    }),
    overrideExisting: false
  });
export { injectedRtkApi as enhancedApi };
export type GetUninvitedPeopleApiResponse =
  /** status 200 Shared people details found. */ {
    ok?: boolean;
    data?: UnsharedPeople;
    message?: string;
  };
export type GetUninvitedPeopleApiArg = {
  /** Asset ID to filter the Share */
  name: string;
};
export type InvitePeopleApiResponse =
  /** status 201 Share has been created successfully. */ {
    ok?: boolean;
    data?: SharedAssetResponse;
    message?: string;
  };
export type InvitePeopleApiArg = {
  /** Share that needs to be added to the application */
  sharedAssetBody: SharedAssetBody;
};
export type GetInvitedPeopleApiResponse =
  /** status 200 Shared people details found. */ {
    ok?: boolean;
    data?: UnsharedPeople;
    message?: string;
  };
export type GetInvitedPeopleApiArg = {
  /** Asset ID to filter the Share */
  name: string;
};
export type GetContributorsApiResponse =
  /** status 200 Contributors details found. */ {
    ok?: boolean;
    data?: ContributorsType;
    message?: string;
  };
export type GetContributorsApiArg = {
  /** Asset ID to filter the Share */
  type: string;
};
export type GetMySpaceApiResponse =
  /** status 200 Contributors details found. */ {
    ok?: boolean;
    data?: MySpaceResponse;
    message?: string;
  };
export type GetMySpaceApiArg = void;
export type UnsharedPeople = {
  count?: number;
  rows?: {
    id?: string;
    profileImage?: string;
    name?: string;
  };
};
export type SharedAssetResponse = {
  count?: number;
  rows?: {
    id?: string;
    url?: string;
    thumbNailUrl?: string;
    role?: string;
    status?: string;
  }[];
};
export type SharedAssetBody = {
  peopleId?: {
    id?: string;
    roleId?: string;
  };
};
export type ContributorsType = {
  id?: string;
  profileImage?: string;
  name?: string;
  userId?: string;
  subscriberId?: string;
  permissions: {
    id: string;
    permissionId: string;
    roleId?: string;
    permission: string[];
  };
}[];
export type MySpaceResponse = {
  userId?: string;
  subscriberId?: string;
  name?: string;
  profileImage?: string;
  roleName?: string;
}[];
export const {
  useGetUninvitedPeopleQuery,
  useInvitePeopleMutation,
  useGetInvitedPeopleQuery,
  useGetContributorsQuery,
  useGetMySpaceQuery
} = injectedRtkApi;
